import ClinicianPublicHold from "@/components/marketing/ClinicianPublicHold";

const Partners = () => (
  <ClinicianPublicHold
    eyebrow="Partnership review"
    title="Public partnership inquiries and pilot offers are paused."
    description="This route no longer collects names, work email addresses, organizations, roles, phone numbers, messages, patient counts, research proposals, or letters of intent. Partnership, research, pilot, and commercial discussions require a reviewed scope and an approved non-sensitive contact process before reopening."
  />
);

export default Partners;
